/**
 * Tab-scoped business ID (sessionStorage only; do not use localStorage for businessId).
 * Safe for SSR: returns null when sessionStorage is not defined.
 */
export function getBusinessIdFromSessionStorage(): string | null {
  return typeof sessionStorage !== 'undefined'
    ? // eslint-disable-next-line pbt-portal/no-localstorage-businessid -- Implementation of the allowed escape hatch; Redux not available here.
      sessionStorage.getItem('businessId')
    : null
}
